import "./style.css";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { AuthenticationContext } from "../contexts/authentication.js";
import logoImage from "../assets/logo.png";
import { Navigate } from "react-router-dom";
import { Spinner } from "reactstrap";
import { SelectedFeatureContext } from "../contexts/selectedFeature";
import { SelectedPeriodContext } from "../contexts/selectedPeriod";
import { Alert, Input, Button } from "antd";
import {
  getAccessItem,
  loginRequest,
  getMenuItem,
  getLocalToken,
  checkTokenRequest,
} from "../data/data.facade";
import { useContext, useEffect, useState } from "react";
import { AccessContext } from "../contexts/access";
import { RoutesContext } from "../contexts/routes";

export default function Login() {
  const statusType = {
    none: undefined,
    error: "error",
  };
  const [status, setStatus] = useState(statusType.none);
  const [errorMessage, setErrorMessage] = useState("");
  const { dispatch: dispatchAccess } = useContext(AccessContext);
  const { dispatch: dispatchSelectedFeature } = useContext(
    SelectedFeatureContext
  );
  const { dispatch: dispatchSelectedPeriod } = useContext(
    SelectedPeriodContext
  );
  const [redirect, setRedirect] = useState(false);
  const [username, setUsername] = useState("");
  const userAuthentication = getLocalToken();
  const [isLoading, setIsLoading] = useState(userAuthentication.status);
  const [password, setPassword] = useState("");

  const {
    dispatch: dispatchAuthentication,
    value: AuthenticationContextValue,
  } = useContext(AuthenticationContext);
  const { dispatch: dispatchRoutes } = useContext(RoutesContext);

  useEffect(() => {
    if (userAuthentication.status) {
      setIsLoading(true);
      checkTokenRequest(
        userAuthentication.password,
        userAuthentication.username
      )
        .then(async (validatedToken) => {
          await initializeUserPanel();
          const [feature, period] =
            localStorage.defaultFeature?.split("-") || ["guide", 0];
          dispatchSelectedFeature(feature || "guide");
          dispatchSelectedPeriod(period);
          dispatchAuthentication(
            userAuthentication.username,
            validatedToken,
            true
          );
          setRedirect(true);
        })
        .catch(() => {
          dispatchAuthentication();
          setErrorMessage("Your session has expired. Please log in again.");
          setIsLoading(false);
        });
    }
  }, [0]);

  useEffect(() => {
    if (!AuthenticationContextValue.loggedIn || redirect) return;
    initializeUserPanel()
      .then(() => {
        const [feature, period] = localStorage.defaultFeature?.split("-") || [
          "guide",
          0,
        ];
        dispatchSelectedFeature(feature || "guide");
        dispatchSelectedPeriod(period);
        setRedirect(true);
      })
      .catch((error) => {
        console.error(error);
        dispatchAuthentication();
        setErrorMessage(
          "We couldn't load your account. Please try logging in again."
        );
        setIsLoading(false);
      });
  }, [AuthenticationContextValue]);

  function sendLoginRequest() {
    setStatus(statusType.none);
    setErrorMessage("");
    if (username.trim() === "") {
      setStatus(statusType.error);
      return;
    }
    setIsLoading(true);
    loginRequest(username, password)
      .then(async (response) => {
        const status = Boolean(response);
        setStatus(status ? statusType.none : statusType.error);
        dispatchAuthentication(username, response, status);
        if (!status) {
          setErrorMessage("Invalid username or password.");
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.error(error);
        setStatus(statusType.error);
        setErrorMessage("Login failed. Please try again.");
        dispatchAuthentication();
        setIsLoading(false);
      });
  }

  async function initializeUserPanel() {
    await getAccess();
    await getRoutes();
  }

  async function getAccess() {
    const { access, expire } = await getAccessItem();
    dispatchAccess(access);
    localStorage.expire = expire;
    const [, period] = localStorage.defaultFeature?.split("-") || [
      "guide",
      0,
    ];
    if (period !== 0) {
      if (!access.includes(Number(period))) {
        localStorage.removeItem("defaultFeature");
        dispatchSelectedFeature("guide");
        dispatchSelectedPeriod(period);
        return;
      }
    }
  }
  async function getRoutes() {
    const routes = await getMenuItem();
    dispatchRoutes(routes);
  }

  return (
    <>
      {redirect ? <Navigate to={`/page/0`} /> : <></>}
      <div className="login-wrapper">
        {isLoading ? (
          <div className="loading">
            <span className="loading-text">Loading</span> <Spinner size="sm" />
          </div>
        ) : (
          <div className="authentication-panel">
            <img src={logoImage} alt="Soshianest Logo" />
            {errorMessage ? (
              <Alert
                className="authentication-error"
                message={errorMessage}
                type="error"
                showIcon
              />
            ) : null}
            <Input
              className="authentication-input"
              placeholder="Username"
              status={status}
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              prefix={<UserOutlined />}
            />
            <Input
              className="authentication-input"
              placeholder="Password"
              status={status}
              value={password}
              type="password"
              onChange={(e) => setPassword(e.target.value)}
              prefix={<LockOutlined />}
            />
            <Button
              onClick={sendLoginRequest}
              className="authentication-submit"
              type="primary"
            >
              Login
            </Button>
          </div>
        )}
      </div>
    </>
  );
}
